"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VERSION = exports.RRWEB_VERSION = exports.DIST_METHOD = exports.BUILD_ENV = void 0;
/**
 * @file This file exposes NPM build environment variables. These variables will
 * be overridden with babel.
 */

/**
 * Exposes the version of the agent
 */
const VERSION = exports.VERSION = "1.266.0";

/**
 * Exposes the build type of the agent
 * Valid values are LOCAL, PROD, DEV
 */
const BUILD_ENV = exports.BUILD_ENV = 'NPM';

/**
 * Exposes the distribution method of the agent
 * Valid valuse are CDN, NPM
 */
const DIST_METHOD = exports.DIST_METHOD = 'NPM';

/**
 * Exposes the lib version of rrweb
 */
const RRWEB_VERSION = exports.RRWEB_VERSION = "2.0.0-alpha.12";